import { Action } from "@ngrx/store";
import { ModTable } from 'core-lib';

export const STAGE_ITEM = '[EXPORT] Stage Item';
export const STAGE_TABLE = '[EXPORT] Stage Table';
export const STAGE_CHART = '[EXPORT] Stage Chart';
export const STAGE_LINESCALE = '[EXPORT] Stage Linescale';
export const UNSTAGE_ITEM = '[EXPORT] UnStage Item';

export const CANCEL_STAGING = '[EXPORT] Cancel Staging';
export const ENABLE_EXPORT = '[EXPORT] Enable Export';
export const DISABLE_EXPORT = '[EXPORT] Disable Export';
export const STAGE_MANY = '[EXPORT] Stage Many';

export const SAVE_TABLE_EXCEL = '[EXPORT] Save Table To Excel';

export class SaveTableExcel implements Action {
    readonly type = SAVE_TABLE_EXCEL;

    /** port a single table
     * @param payload Table ID and Cache Key
     */
    constructor(public payload: { tableId: string }) { }
}

export class StageMany implements Action {
    readonly type = STAGE_MANY;

    constructor(public payload: any[]) { }
}

export class StageTable implements Action {
    readonly type = STAGE_TABLE;

    constructor(public payload: ModTable) { }
}

export class StageChart implements Action {
    readonly type = STAGE_CHART;

    constructor(public payload: { id: string, dataURI: string, caption?: string }) { }
}

export class StageLinescale implements Action {
    readonly type = STAGE_LINESCALE;

    constructor(public payload: { id: string, dataURI: string }) { }
}

class StageItem implements Action {
    readonly type = STAGE_ITEM;

    constructor(public payload: any) { }
}

export class UnstageItem implements Action {
    readonly type = UNSTAGE_ITEM;

    /**
     * This removes the item of the ID provided from the redux staging state.
     * @param payload ID of the item to be unstage
     */
    constructor(public payload: string) { }
}

export class CancelStaging implements Action {
    readonly type = CANCEL_STAGING;
}

export class EnableExport implements Action {
    readonly type = ENABLE_EXPORT;
}

export class DisableExport implements Action {
    readonly type = DISABLE_EXPORT;
}

export type ExportAction = StageItem | UnstageItem | CancelStaging | EnableExport | DisableExport | StageMany | StageChart | StageTable | StageLinescale | SaveTableExcel;


// export const stageItem = createAction(
//     '[EXPORT] Stage Item',
//     props<{ data: any }>()
// );

// export const unstageItem = createAction(
//     '[EXPORT] UnStage Item',
//     props<{ id: string }>()
// );

// export const assignToPage = createAction(
//     '[EXPORT] Assign to Page',
//     props<{ data: any }>()
// );

// export const setActivePage = createAction(
//     '[EXPORT] Set Active',
//     props<{ index: number }>()
// );

// export const cancelStaging = createAction(
//     '[EXPORT] Cancel Staging'
// );

// export const enableExport = createAction('[EXPORT] Enable');
// export const disableExport = createAction('[EXPORT] Disable');
// export const ConfirmPage = createAction('[EXPORT] Confirm Page');
